module.exports = __webpack_public_path__ + "img/face.77b55c89.png";